import ProtectedRoute from './protectedRoute'

export default ProtectedRoute
